export const GET_PERMISSIONS = "GET_PERMISSIONS"
export const GET_PERMISSIONS_SUCCESS = "GET_PERMISSIONS_SUCCESS"
export const GET_PERMISSIONS_FAILED = "GET_PERMISSIONS_FAILED"

export const ASSIGN_PERMISSION = "ASSIGN_PERMISSION"
export const ASSIGN_PERMISSION_SUCCESS = "ASSIGN_PERMISSION_SUCCESS"
export const ASSIGN_PERMISSION_FAILED = "ASSIGN_PERMISSION_FAILED"
